import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import LinkButton from '@/components/link_button/Index.vue';
import PageTitle from '@/components/v2/PageTitle.vue';
import { InquiryRequestStatus } from '@/helpers/entities/enums/v2/InquiryRequestStatus';
import { INQUIRIES_ROUTE } from '@/helpers/constants/InquiryRoutes';
import BaseSubtitle from '@/components/v2/BaseSubtitle';
import BaseInnerLoader from '@/components/v2/BaseInnerLoader';
import ActionButton from '@/components/action_button/Index.vue';
import InquiryRequest from '@/plugins/graphql/queries/v2/inquiry/inquiries-by-status.gql';
import { InquiryRequestFullModel } from '@/helpers/entities/models/InquiryRequestFullModel';
import CurrentDayInquiryCount from '@/plugins/graphql/queries/v2/inquiry/current-day-inquiry-count.gql';
import JsonCSV from 'vue-json-csv';
import Avatar from '@/components/avatar/Index.vue';
/**
 * Inquiries Page
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version {0.1.19}
 */
let Inquiries = class Inquiries extends Mixins(RouterParamsAppMixin, ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.inquiries = null;
        this.inquiriesCountByCurrentDay = 0;
        this.loading = false;
    }
    get inquiriesIndex() {
        return INQUIRIES_ROUTE.name;
    }
    get inquiriesByStatus() {
        return 'inquiry-by-status';
    }
    get openInquiries() {
        return InquiryRequestStatus.Open;
    }
    get closedInquiries() {
        return InquiryRequestStatus.Closed;
    }
    get headers() {
        return [
            {
                text: 'INQUIRY NUMBER',
                value: 'transactionNumber',
                sortable: false,
            },
            {
                text: 'INQUIRY DATE',
                value: 'inquiryDate',
                sortable: false,
            },
            {
                text: 'USER',
                value: 'pageRecipientName$',
                sortable: false,
                hasAvatar: true,
                avatarValue: 'pageRecipientProfilePic$',
            },
            {
                text: 'INQUIRY TYPE',
                value: 'category',
                sortable: false,
            },
            {
                text: 'ASSIGNEE',
                value: 'assigneeName$',
                sortable: false,
                isUser: true,
            },
            {
                text: 'STATUS',
                value: 'status',
                sortable: false,
            },
            {
                text: '',
                value: 'action',
                sortable: false,
            },
        ];
    }
    get queryOnFlight() {
        return this.$apollo.queries.inquiries.loading;
    }
    get labels() {
        return {
            transactionNumber: 'Transaction No.',
            message: 'Message',
            inquiryDate$: 'Inquiry Date',
            pageRecipientName$: 'Customer Name',
            email: 'Email',
            category: 'Category',
            assigneeName$: 'Assignee Name',
            productName$: 'Product Name',
            status: 'Status',
            contactDetails: 'Contact Number',
            companyName: 'Company Name',
        };
    }
    get fields() {
        return Object.keys(this.labels);
    }
    get dataForCsV() {
        const self = this;
        if (self.inquiries) {
            return self.inquiries.map((inquiry) => {
                const dataToExport = {
                    ...inquiry,
                    contactDetails: inquiry.contactDetails,
                };
                const customField = inquiry.customAnswers.find((customAnswer) => customAnswer.customField.title === 'Company Name');
                if (customField) {
                    const companyName = customField.content;
                    return Object.assign(dataToExport, { companyName });
                }
                return dataToExport;
            });
        }
        return [];
    }
    onViewDetails(uuid) {
        this.$router.push({
            name: 'inquiry-details',
            params: { uuid },
        });
    }
};
__decorate([
    Prop({ type: String, default: () => null })
], Inquiries.prototype, "status", void 0);
Inquiries = __decorate([
    Component({
        components: {
            ActionButton,
            BaseSubtitle,
            BaseInnerLoader,
            JsonCSV,
            LinkButton,
            PageTitle,
            Avatar,
        },
        apollo: {
            inquiries: {
                query: InquiryRequest,
                variables() {
                    return {
                        appUuid: this.appUUID,
                        status: this.status,
                    };
                },
                update(data) {
                    const nodes = data.inquiriesByStatus.edges;
                    return nodes.map((inqNode) => {
                        return new InquiryRequestFullModel(inqNode.node);
                    });
                },
            },
            inquiriesCountByCurrentDay: {
                query: CurrentDayInquiryCount,
                variables() {
                    return { appUuid: this.appUUID };
                },
            },
        },
    })
], Inquiries);
export default Inquiries;
